<script lang="ts"></script>

<style lang="scss">
    td {
        background: var(--color-body-background) !important;
        border-width: 0 !important;
    }
</style>

<tr>
    <td colspan="100">&nbsp;</td>
</tr>
